import type { LscLeague } from './types';

export const LEAGUE_LOGO_MAX_BYTES = 2 * 1024 * 1024;
export const LEAGUE_LOGO_ACCEPT = 'image/png,image/jpeg,image/webp';

export const LEAGUE_LOGO_COPY = {
  title: 'League logo',
  helper: 'Upload a logo to personalize this league’s Stream Center workspace.',
  recommended:
    'Recommended: square 1024×1024 PNG or WebP with transparent background. Horizontal logos are supported and will be fit automatically.',
  acceptedTypes: 'Accepted: PNG, JPEG, WebP. Max size: 2 MB.',
} as const;

export function leagueInitials(name?: string | null): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return 'LSC';
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
  }
  return trimmed.slice(0, 3).toUpperCase();
}

export function leagueLogoAltText(league: Pick<LscLeague, 'name'>): string {
  return `${league.name} logo`;
}

export function validateLeagueLogoFile(file: File): string | null {
  const allowed = ['image/png', 'image/jpeg', 'image/webp'];
  if (!allowed.includes(file.type)) {
    return 'Unsupported file type. Use PNG, JPEG, or WebP.';
  }
  if (file.size > LEAGUE_LOGO_MAX_BYTES) {
    return 'Logo file is too large. Maximum size is 2 MB.';
  }
  return null;
}
